import React, { useState, useRef, useEffect, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import propTypes from 'prop-types';
import { CheckboxList } from 'shared/components';
import './ColumnManager.scss';
import Wheel from 'assets/svgs/settings.svg';
import _ from 'lodash';

const ColumnManager = (props) => {
  const { t } = useTranslation();
  const { headerColumns, initialColumns, setNewHeaders, tab } = props;
  const [managerList, setManagerList] = useState(headerColumns);
  const [display, setDisplay] = useState(false);
  const [showAllButton, setShowAllButton] = useState(false);
  const manageColumnsRef = useRef();

  const setInitialColumns = useCallback(() => {
    let initialHeaderColumns = initialColumns;
    const savedColumns = JSON.parse(window.sessionStorage.getItem(`${tab}-columns`));

    if (savedColumns?.length && initialColumns) {
      initialHeaderColumns = initialColumns.map(
        (obj) => savedColumns.find((o) => obj.key === o.key) || { ...obj, checked: false }
      );

      setNewHeaders(initialHeaderColumns);
    } else {
      initialColumns &&
        initialColumns.forEach((column) => {
          column.checked = true;
        });
    }

    setManagerList(initialHeaderColumns);
  }, [initialColumns, tab, setNewHeaders]);

  const handleColumnManagerCheckbox = (e) => {
    const list = _.cloneDeep(managerList);
    const selected = list.find((item) => item.key === e.target.name);

    selected['checked'] = !selected['checked'];
    if (list.every((item) => item.checked)) {
      setShowAllButton(false);
    } else {
      setShowAllButton(true);
    }
    setManagerList(list);
  };

  const handleColumnManagerSelectAll = () => {
    const list = managerList;
    list.forEach((x) => (x.checked = true));
    setManagerList(list);
    setShowAllButton(false);
  };

  const handleColumnManagerApply = () => {
    let newHeaders = [];

    managerList.forEach((headerColumn, idx) => {
      if (headerColumn.checked && idx < managerList.length) {
        newHeaders.push(headerColumn);
      }
    });

    setDisplay(false);
    props.setNewHeaders && props.setNewHeaders(newHeaders);
  };

  const openColumnManager = () => {
    if (managerList.every((item) => item.checked)) {
      setShowAllButton(false);
    } else {
      setShowAllButton(true);
    }
    setDisplay(!display);
  };

  useEffect(() => {
    setInitialColumns();
  }, [setInitialColumns]);

  return (
    <div className="manageColumns__Container">
      <span className="manageColumns__tooltip__Container">
        <button
          aria-label="Manage columns"
          aria-haspopup="true"
          aria-expanded={display}
          onClick={() => openColumnManager()}
          className="roster__ManageColumns">
          <Wheel />
        </button>
        <span className="manageColumns__tooltip">Manage columns</span>
      </span>
      {display && (
        <div className="manageColumns__ArrowBox manageColumns__Ajusted" ref={manageColumnsRef}>
          <div className="manageColumns__Arrow manageColumns_Moved-arrow"></div>
          <div className="cmb__Container" role="group">
            <CheckboxList
              onChange={(e) => handleColumnManagerCheckbox(e)}
              checkboxes={managerList}
            />
            <div className="cmb__Controls">
              <button
                type="button"
                className="bigButton apply__Button"
                onClick={() => handleColumnManagerApply()}>
                {t('common.labels.apply')}
              </button>
              {showAllButton && (
                <span tabIndex="0" className="cancel__Link" onClick={handleColumnManagerSelectAll}>
                  {t('common.labels.selectAll')}
                </span>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

ColumnManager.propTypes = {
  options: propTypes.arrayOf(propTypes.shape({ checked: propTypes.bool, name: propTypes.string })),
  apply: propTypes.func,
  headerColumns: propTypes.array,
};

ColumnManager.defaultProps = {
  options: [],
};

export default ColumnManager;
